import { render } from "./NewCard.vue?vue&type=template&id=aedcc754"
import script from "./NewCard.vue?vue&type=script&lang=js"
export * from "./NewCard.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "aedcc754"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('aedcc754', script)) {
    api.reload('aedcc754', script)
  }
  
  module.hot.accept("./NewCard.vue?vue&type=template&id=aedcc754", () => {
    api.rerender('aedcc754', render)
  })

}

script.__file = "src/views/settings/modules/NewCard.vue"

export default script